import React from "react";
import Skeleton from "react-loading-skeleton";
import { useTranslation } from "react-i18next";
import type { TransformedProduct } from "../../../types/productApiTypes";

interface ProductInformationProps {
  productName: string;
  shortDescription: string | null;
  variationsLoading: boolean;
}

const ProductInformation: React.FC<ProductInformationProps> = ({
  productName,
  shortDescription,
  variationsLoading,
}) => {
  const { t } = useTranslation();

  const isLoading = variationsLoading;

  return (
    <>
      <h1 className="product-title">{productName}</h1>

      {/* REMOVED: Price display block */}

      {/* REMOVED: Stock status display block */}

      {shortDescription && (
        <div
          className="product-short-description"
          dangerouslySetInnerHTML={{ __html: shortDescription }}
        />
      )}
    </>
  );
};

export default ProductInformation;
